<template>
  <ul class="sam-text-list">
    <li
      v-for="(item, index) in parsedItems"
      :key="`item-${index}`"
      class="sam-text-list__list-item"
    >
      <template v-if="hasDefaultSlot">
        <slot
          :item="item"
          :index="index"
        />
      </template>
      <template v-else>
        <hr
          v-if="item.id === 'divider'"
          class="sam-text-list__divider"
        />
        <SamTextListItem
          v-else
          :item="item"
          @click="onClick($event, item)"
        />
      </template>
    </li>
  </ul>
</template>

<script>
import SamTextListItem, {
  TEXT_LIST_ITEM_STYLES,
} from './SamTextListItem.vue';

export default {
  name: 'SamTextList',
  components: { SamTextListItem },
  props: {
    /**
     * The items to be shown on the list. They must follow a specific structure.
     * @type TextListItem[]
     */
    items: {
      required: true,
      type: Array,
      default: () => [],
    },
    /**
     * Propagate click event from activator to menu content. Use it if you have
     * a select aside with other selects and the select content overlaps eachother when
     * opened.
     */
    propagateClick: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    parsedItems() {
      return this.items.map(this.parseItem);
    },
    hasDefaultSlot() {
      /**
       * For some reason, when using scoped slot properties the $slots.default verifier doesn't work.
       * So a workaround that was found was to check if the default scoped slot also existed.
       */
      return !!this.$slots.default || !!this.$scopedSlots.default;
    },
  },
  methods: {
    parseItem(item = {}) {
      return {
        id: item.id,
        label: item.label,
        badge: item.badge,
        value: item.value,
        hasNotification: !!item.hasNotification,
        disabled: !!item.disabled,
        icon: item.icon,
        tooltip: item.tooltip,
        samStyle: this.validateStyle(item.samStyle),
        description: item.description,
      };
    },
    validateStyle(style) {
      if (!Object.values(TEXT_LIST_ITEM_STYLES).includes(style)) {
        return TEXT_LIST_ITEM_STYLES.DEFAULT;
      }
      return style;
    },
    onClick($event, item) {
      if(!this.propagateClick) {
        $event.stopPropagation();
      }
      this.$emit('item-click', item);
    }
  },
};
</script>

<style lang="scss" scoped>
.sam-text-list__list-item {
  position: relative;
}

.sam-text-list__divider {
  @extend .m-0;
  border: none;
  height: $size--0--fourth;
  background-color: $neutral--30;
}
</style>
